/**
 * Media calculation helpers — orchestrate by media type.
 * Single source of truth for admin-side media buying calculations.
 */
import { MEDIA_TYPES, getMediaTypeFromProduct } from './mediaTypeConstants';
import { calculatePrintMediaTotal } from './printMedia';
import { calculateRadioTotal } from './radio';
import { calculateTelevisionTotal } from './television';
import { calculateHoardingTotal, calculateHoardingRowTotal } from './hoarding';
import { calculateMultiplexTotal } from './multiplex';
import { calculateDoohTotal } from './dooh';
import { calculateAirportTotal } from './airport';
import { calculateOfflineBtlTotal } from './offlineBtl';
import { calculateOtherTotal } from './other';

export function getMediaTotalByType(mediaType, productData, selection) {
  const variant = productData?.ProductsVariantions?.[0] || productData?.mediaVariation || {};

  switch (mediaType) {
    case MEDIA_TYPES.PRINT_MEDIA:
      return calculatePrintMediaTotal(variant, selection);
    case MEDIA_TYPES.RADIO:
      return calculateRadioTotal(variant, selection);
    case MEDIA_TYPES.TELEVISION:
      return calculateTelevisionTotal(variant, selection);
    case MEDIA_TYPES.HOARDING:
      return calculateHoardingTotal(variant, selection);
    case MEDIA_TYPES.MULTIPLEX:
      return calculateMultiplexTotal(variant, selection);
    case MEDIA_TYPES.DOOH:
      return calculateDoohTotal(variant, selection);
    case MEDIA_TYPES.AIRPORT:
      return calculateAirportTotal(variant, selection);
    case MEDIA_TYPES.OFFLINE_BTL:
      return calculateOfflineBtlTotal(variant, selection);
    case MEDIA_TYPES.OTHER:
    default:
      return calculateOtherTotal(variant, selection);
  }
}

export {
  MEDIA_TYPES,
  getMediaTypeFromProduct,
  calculatePrintMediaTotal,
  calculateRadioTotal,
  calculateTelevisionTotal,
  calculateHoardingTotal,
  calculateHoardingRowTotal,
  calculateMultiplexTotal,
  calculateDoohTotal,
  calculateAirportTotal,
  calculateOfflineBtlTotal,
  calculateOtherTotal,
};

export {
  getDaysPerTimelineUnit,
  timelineMultiplier,
  timeslotMultiplier,
  timelineDaysMultiplier,
  getMinTimelineDays,
  getMultiplesOfMin,
  slotTenFactor,
  airportTimelineFactor,
  tenBlockFactor,
  HOARDING_BLOCK_DAYS,
} from './multipliers';
